// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as OrderRoutes from "../Order/OrderRoutes.res.js";
import * as OrderStatus from "../../modules/Order/OrderStatus.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TableDateCell from "../../resources/tables/TableDateCell.res.js";
import * as Client from "@apollo/client";
import * as AmountTableCell from "../../modules/TableCell/AmountTableCell.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as OrderStatusBadges from "../../modules/Order/OrderStatusBadges.res.js";
import * as OrderTableActions from "../../modules/Order/OrderTableActions.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderNameTableCell from "../../modules/Order/OrderNameTableCell.res.js";
import * as OrderUrlQueryString from "../../modules/Order/OrderUrlQueryString.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let make = React.memo(props => {
  let notification = props.notification;
  if (notification === undefined) {
    return null;
  }
  let tmp;
  tmp = notification.TAG === "Ok" ? ({
      TAG: "Success",
      _0: notification._0
    }) : ({
      TAG: "Danger",
      _0: notification._0
    });
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Banner.make, {
      textStatus: tmp,
      onRequestClose: props.onRequestClose
    }),
    spaceX: "large",
    spaceTop: "medium"
  });
});

let SupplierOrderListNotificationBanner = {
  make: make
};

let Raw = {};

let query = Client.gql(["query SupplierOrderListPageParentQuery($id: ID!)  {\nsupplier(id: $id)  {\n__typename  \nid  \ncompanyName  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.supplier;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.shop;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      companyName: value$1.companyName,
      shop: {
        __typename: value$2.__typename,
        id: value$2.id
      }
    };
  }
  return {
    supplier: tmp
  };
}

function serialize(value) {
  let value$1 = value.supplier;
  let supplier;
  if (value$1 !== undefined) {
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.companyName;
    let value$6 = value$1.id;
    let value$7 = value$1.__typename;
    supplier = {
      __typename: value$7,
      id: value$6,
      companyName: value$5,
      shop: shop
    };
  } else {
    supplier = null;
  }
  return {
    supplier: supplier
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let ParentQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let ParentQuery_refetchQueryDescription = include.refetchQueryDescription;

let ParentQuery_useLazy = include.useLazy;

let ParentQuery_useLazyWithVariables = include.useLazyWithVariables;

let ParentQuery = {
  ParentQuery_inner: ParentQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: ParentQuery_refetchQueryDescription,
  use: use,
  useLazy: ParentQuery_useLazy,
  useLazyWithVariables: ParentQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query SupplierOrderListPageQuery($supplierId: ID!, $after: String, $before: String, $filterBy: InputSupplierOrdersFilter, $first: Int, $last: Int, $search: String)  {\nsupplier(id: $supplierId)  {\n__typename  \nid  \norders(after: $after, before: $before, filterBy: $filterBy, first: $first, last: $last, search: $search)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedName  \nshopName  \nsupplierCompanyName  \nissueDate  \nreceptionFinishedAt  \nformattedStatus  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntotalProductsQuantity  \ntotalProductsExpectedQuantity  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.supplier;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.orders;
    let value$3 = value$2.pageInfo;
    let value$4 = value$3.startCursor;
    let value$5 = value$3.endCursor;
    let value$6 = value$2.edges;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      orders: {
        __typename: value$2.__typename,
        pageInfo: {
          __typename: value$3.__typename,
          startCursor: !(value$4 == null) ? value$4 : undefined,
          endCursor: !(value$5 == null) ? value$5 : undefined
        },
        totalCount: value$2.totalCount,
        edges: value$6.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.receptionFinishedAt;
          let value$3 = value$1.formattedStatus;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              id: value$1.id,
              formattedName: value$1.formattedName,
              shopName: value$1.shopName,
              supplierCompanyName: value$1.supplierCompanyName,
              issueDate: Scalar.Datetime.parse(value$1.issueDate),
              receptionFinishedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
              formattedStatus: value$3.map(value => {
                switch (value) {
                  case "ACCEPTED" :
                    return "ACCEPTED";
                  case "ARCHIVED" :
                    return "ARCHIVED";
                  case "DRAFT" :
                    return "DRAFT";
                  case "FINALIZED" :
                    return "FINALIZED";
                  case "NOT_RECEIVED" :
                    return "NOT_RECEIVED";
                  case "PAID" :
                    return "PAID";
                  case "RECEIVED" :
                    return "RECEIVED";
                  case "RECEIVING" :
                    return "RECEIVING";
                  case "REFUSED" :
                    return "REFUSED";
                  case "SENT" :
                    return "SENT";
                  case "TO_PAY" :
                    return "TO_PAY";
                  default:
                    throw {
                      RE_EXN_ID: "Not_found",
                      Error: new Error()
                    };
                }
              }),
              totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
              totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
              totalProductsQuantity: value$1.totalProductsQuantity,
              totalProductsExpectedQuantity: value$1.totalProductsExpectedQuantity
            }
          };
        })
      }
    };
  }
  return {
    supplier: tmp
  };
}

function serialize$1(value) {
  let value$1 = value.supplier;
  let supplier;
  if (value$1 !== undefined) {
    let value$2 = value$1.orders;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.totalProductsExpectedQuantity;
      let value$3 = value$1.totalProductsQuantity;
      let value$4 = value$1.totalAmountIncludingTaxes;
      let value$5 = value$1.totalAmountExcludingTaxes;
      let value$6 = value$1.formattedStatus;
      let formattedStatus = value$6.map(value => {
        if (value === "TO_PAY") {
          return "TO_PAY";
        } else if (value === "DRAFT") {
          return "DRAFT";
        } else if (value === "NOT_RECEIVED") {
          return "NOT_RECEIVED";
        } else if (value === "REFUSED") {
          return "REFUSED";
        } else if (value === "FINALIZED") {
          return "FINALIZED";
        } else if (value === "ACCEPTED") {
          return "ACCEPTED";
        } else if (value === "PAID") {
          return "PAID";
        } else if (value === "RECEIVING") {
          return "RECEIVING";
        } else if (value === "SENT") {
          return "SENT";
        } else if (value === "RECEIVED") {
          return "RECEIVED";
        } else {
          return "ARCHIVED";
        }
      });
      let value$7 = value$1.receptionFinishedAt;
      let receptionFinishedAt = value$7 !== undefined ? Scalar.Datetime.serialize(value$7) : null;
      let value$8 = value$1.issueDate;
      let value$9 = Scalar.Datetime.serialize(value$8);
      let value$10 = value$1.supplierCompanyName;
      let value$11 = value$1.shopName;
      let value$12 = value$1.formattedName;
      let value$13 = value$1.id;
      let value$14 = value$1.__typename;
      let node = {
        __typename: value$14,
        id: value$13,
        formattedName: value$12,
        shopName: value$11,
        supplierCompanyName: value$10,
        issueDate: value$9,
        receptionFinishedAt: receptionFinishedAt,
        formattedStatus: formattedStatus,
        totalAmountExcludingTaxes: value$5,
        totalAmountIncludingTaxes: value$4,
        totalProductsQuantity: value$3,
        totalProductsExpectedQuantity: value$2
      };
      let value$15 = value.__typename;
      return {
        __typename: value$15,
        node: node
      };
    });
    let value$4 = value$2.totalCount;
    let value$5 = value$2.pageInfo;
    let value$6 = value$5.endCursor;
    let endCursor = value$6 !== undefined ? value$6 : null;
    let value$7 = value$5.startCursor;
    let startCursor = value$7 !== undefined ? value$7 : null;
    let value$8 = value$5.__typename;
    let pageInfo = {
      __typename: value$8,
      startCursor: startCursor,
      endCursor: endCursor
    };
    let value$9 = value$2.__typename;
    let orders = {
      __typename: value$9,
      pageInfo: pageInfo,
      totalCount: value$4,
      edges: edges
    };
    let value$10 = value$1.id;
    let value$11 = value$1.__typename;
    supplier = {
      __typename: value$11,
      id: value$10,
      orders: orders
    };
  } else {
    supplier = null;
  }
  return {
    supplier: supplier
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInputSupplierOrdersFilter(inp) {
  let a = inp.status;
  let a$1 = inp.createdAt;
  let a$2 = inp.issueDate;
  let a$3 = inp.receptionFinishedAt;
  let a$4 = inp.shopIds;
  return {
    status: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter(a$1) : undefined,
    issueDate: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    receptionFinishedAt: a$3 !== undefined ? serializeInputObjectDateFilter(a$3) : undefined,
    shopIds: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.after;
  let a$1 = inp.before;
  let a$2 = inp.filterBy;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.search;
  return {
    supplierId: inp.supplierId,
    after: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    filterBy: a$2 !== undefined ? serializeInputObjectInputSupplierOrdersFilter(a$2) : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    search: a$5 !== undefined ? a$5 : undefined
  };
}

function makeVariables$1(supplierId, after, before, filterBy, first, last, search, param) {
  return {
    supplierId: supplierId,
    after: after,
    before: before,
    filterBy: filterBy,
    first: first,
    last: last,
    search: search
  };
}

function makeInputObjectInputSupplierOrdersFilter(status, createdAt, issueDate, receptionFinishedAt, shopIds, param) {
  return {
    status: status,
    createdAt: createdAt,
    issueDate: issueDate,
    receptionFinishedAt: receptionFinishedAt,
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

let Query_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputSupplierOrdersFilter: serializeInputObjectInputSupplierOrdersFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputSupplierOrdersFilter: makeInputObjectInputSupplierOrdersFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let Query_refetchQueryDescription = include$1.refetchQueryDescription;

let Query_useLazy = include$1.useLazy;

let Query_useLazyWithVariables = include$1.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputSupplierOrdersFilter: serializeInputObjectInputSupplierOrdersFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputSupplierOrdersFilter: makeInputObjectInputSupplierOrdersFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use$1,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

let statuses = [
  "DRAFT",
  "FINALIZED",
  "ACCEPTED",
  "RECEIVING",
  "RECEIVED",
  "TO_PAY",
  "PAID",
  "ARCHIVED"
];

function encoder(param) {
  return [
    Stdlib_Option.map(param.status, OrderStatus.toString),
    Stdlib_Option.map(param.issueDateRange, param => [
      param[0].getTime(),
      param[1].getTime()
    ]),
    Stdlib_Option.map(param.receptionDateRange, param => [
      param[0].getTime(),
      param[1].getTime()
    ])
  ];
}

function decoder(param) {
  return {
    TAG: "Ok",
    _0: {
      status: Stdlib_Option.map(param[0], OrderStatus.fromStringExn),
      issueDateRange: Stdlib_Option.flatMap(param[1], range => {
        if (range.length !== 2) {
          return;
        }
        let start = range[0];
        let end = range[1];
        return [
          new Date(start),
          new Date(end)
        ];
      }),
      receptionDateRange: Stdlib_Option.flatMap(param[2], range => {
        if (range.length !== 2) {
          return;
        }
        let start = range[0];
        let end = range[1];
        return [
          new Date(start),
          new Date(end)
        ];
      })
    }
  };
}

function useJsonCodec() {
  return JsonCodec.object3(encoder, decoder, JsonCodec.optional(JsonCodec.field("status", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("issueDateRange", JsonCodec.array(JsonCodec.float))), JsonCodec.optional(JsonCodec.field("receptionDateRange", JsonCodec.array(JsonCodec.float))));
}

let Filters = {
  statuses: statuses,
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

let Row = {};

function SupplierOrderListPage$SupplierOrderReceptionQuantityCell(props) {
  let statuses = props.statuses;
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(TextStyle.make, {
        children: OrderStatus.has(statuses, "RECEIVING") || OrderStatus.has(statuses, "RECEIVED") || OrderStatus.has(statuses, "ARCHIVED") ? props.totalProductsQuantity.toString() : "—",
        weight: "semibold"
      }),
      JsxRuntime.jsx(TextStyle.make, {
        children: " / " + props.totalProductsExpectedQuantity.toString()
      })
    ]
  });
}

let SupplierOrderReceptionQuantityCell = {
  make: SupplierOrderListPage$SupplierOrderReceptionQuantityCell
};

function makeQueryVariables(defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    supplierId: defaultQueryVariables.supplierId,
    after: connectionArguments.after,
    before: connectionArguments.before,
    filterBy: filterBy,
    first: connectionArguments.first,
    last: connectionArguments.last,
    search: search
  };
}

function makeQueryVariablesFilterBy(param) {
  let receptionDateRange = param.receptionDateRange;
  let issueDateRange = param.issueDateRange;
  let status = Stdlib_Option.map(param.status, OrderStatus.toString);
  return {
    status: status !== undefined ? ({
        _in: [status]
      }) : undefined,
    createdAt: undefined,
    issueDate: issueDateRange !== undefined ? ({
        _after: undefined,
        _before: undefined,
        _between: [
          Scalar.Datetime.serialize(issueDateRange[0]),
          Scalar.Datetime.serialize(issueDateRange[1])
        ]
      }) : undefined,
    receptionFinishedAt: receptionDateRange !== undefined ? ({
        _after: undefined,
        _before: undefined,
        _between: [
          Scalar.Datetime.serialize(receptionDateRange[0]),
          Scalar.Datetime.serialize(receptionDateRange[1])
        ]
      }) : undefined,
    shopIds: undefined
  };
}

function totalCountFromQueryData(param) {
  return Stdlib_Option.getOr(Stdlib_Option.map(param.supplier, param => param.orders.totalCount), 0);
}

function cursorsFromQueryData(param) {
  let supplier = param.supplier;
  return [
    Stdlib_Option.flatMap(supplier, param => param.orders.pageInfo.startCursor),
    Stdlib_Option.flatMap(supplier, param => param.orders.pageInfo.endCursor)
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  let supplier = param.supplier;
  if (supplier !== undefined) {
    return supplier.orders.edges.map(edge => ({
      id: edge.node.id,
      supplierId: supplier.id,
      formattedName: edge.node.formattedName,
      shopName: edge.node.shopName,
      issueDate: edge.node.issueDate,
      receptionDate: edge.node.receptionFinishedAt,
      statuses: edge.node.formattedStatus,
      totalAmountExcludingTaxes: edge.node.totalAmountExcludingTaxes,
      totalAmountIncludingTaxes: edge.node.totalAmountIncludingTaxes,
      totalProductsQuantity: edge.node.totalProductsQuantity,
      totalProductsExpectedQuantity: edge.node.totalProductsExpectedQuantity
    }));
  } else {
    return [];
  }
}

function keyExtractor(param) {
  return param.id;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use$1,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

function SupplierOrderListPage(props) {
  let id = props.id;
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  });
  let match$1 = match.data;
  let match$2;
  let exit = 0;
  if (match$1 !== undefined) {
    let supplier = match$1.supplier;
    if (supplier !== undefined) {
      match$2 = [
        supplier.companyName,
        supplier.shop.id
      ];
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    match$2 = match.error !== undefined ? [
        undefined,
        undefined
      ] : [
        I18n.t("Loading") + "...",
        undefined
      ];
  }
  let supplierShopId = match$2[1];
  let pageSubtitle = match$2[0];
  let initialState = Scaffolded.makeInitialState({
    status: undefined,
    issueDateRange: undefined,
    receptionDateRange: undefined
  });
  let match$3 = Scaffolded.use(() => initialState);
  let dispatch = match$3[1];
  let state = match$3[0];
  let defaultQueryVariables = makeVariables$1(id, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let match$4 = React.useState(() => {});
  let setNotification = match$4[1];
  let defaultItem_1 = I18n.t("Not archived");
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined
  };
  let items = statuses.map(status => ({
    TAG: "Option",
    key: OrderStatus.toString(status),
    label: OrderStatus.toLabel(status),
    value: status
  }));
  let match$5 = state.filters;
  let tmp;
  let exit$1 = 0;
  if (match$5.status !== undefined || match$5.issueDateRange !== undefined || match$5.receptionDateRange !== undefined) {
    exit$1 = 1;
  } else {
    tmp = null;
  }
  if (exit$1 === 1) {
    tmp = JsxRuntime.jsx(Scaffold.ResetFiltersButton.make, {
      onPress: () => dispatch({
        TAG: "FiltersUpdated",
        _0: param => initialState.filters
      })
    });
  }
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(Select.make, {
        label: I18n.t("Status"),
        preset: "filter",
        renderValue: param => {
          let selectedItems = param.selectedItems;
          if (selectedItems.length === 1) {
            let match = selectedItems[0];
            if (match.TAG === "Option") {
              let status = match.value;
              if (status !== undefined) {
                return OrderStatusBadges.toBadge(status);
              }
            }
          }
          return JsxRuntime.jsx("span", {
            children: I18n.t("Not archived")
          });
        },
        renderItem: param => {
          let item = param.item;
          if (item.TAG !== "Option") {
            return null;
          }
          let status = item.value;
          if (status !== undefined) {
            return JsxRuntime.jsx(Inline.make, {
              children: OrderStatusBadges.toBadge(status),
              grow: false
            });
          } else {
            return JsxRuntime.jsx("span", {
              children: I18n.t("Not archived")
            });
          }
        },
        sections: [
          {
            items: [defaultItem]
          },
          {
            items: items,
            title: I18n.t("Statuses")
          }
        ],
        value: {
          TAG: "Single",
          _0: state.filters.status
        },
        onChange: change => {
          if (change.TAG !== "Single") {
            return;
          }
          let status = change._0;
          dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              status: status,
              issueDateRange: prev.issueDateRange,
              receptionDateRange: prev.receptionDateRange
            })
          });
        }
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.issueDateRange,
        label: I18n.t("Issue date"),
        placeholder: I18n.t("Since the beginning"),
        onChange: issueDateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            status: prev.status,
            issueDateRange: issueDateRange,
            receptionDateRange: prev.receptionDateRange
          })
        }),
        triggerLabelDisplay: "showPreset"
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.receptionDateRange,
        label: I18n.t("Reception date"),
        placeholder: I18n.t("Since the beginning"),
        onChange: receptionDateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            status: prev.status,
            issueDateRange: prev.issueDateRange,
            receptionDateRange: receptionDateRange
          })
        }),
        triggerLabelDisplay: "showPreset"
      }),
      tmp
    ],
    space: "small"
  });
  let createOrderStateJson = supplierShopId !== undefined ? Primitive_option.some(OrderUrlQueryString.CreateOrder.encode({
      supplierId: id,
      shopId: supplierShopId
    })) : undefined;
  let actions;
  if (createOrderStateJson !== undefined) {
    let href = OrderRoutes.createRoute + "?" + Primitive_option.valFromOption(createOrderStateJson);
    actions = JsxRuntime.jsx(Button.make, {
      label: I18n.t("Create order"),
      variant: "solid",
      tone: "brand",
      size: "legacy_large",
      href: href
    });
  } else {
    actions = null;
  }
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search an order"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let columns = [
    {
      name: I18n.t("Number"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "pct",
          VAL: 20
        },
        margin: "normal",
        sticky: true
      },
      render: param => JsxRuntime.jsx(OrderNameTableCell.make, {
        value: param.formattedName,
        shopName: param.shopName,
        id: param.id
      })
    },
    {
      name: I18n.t("Amount VAT excl."),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        sticky: true
      },
      render: param => JsxRuntime.jsx(AmountTableCell.make, {
        value: param.totalAmountExcludingTaxes,
        secondaryValue: param.totalAmountIncludingTaxes,
        decimalPrecision: 3
      })
    },
    {
      name: I18n.t("Issue date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => JsxRuntime.jsx(TableDateCell.make, {
        value: param.issueDate
      })
    },
    {
      name: I18n.t("Reception date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => JsxRuntime.jsx(TableDateCell.make, {
        value: param.receptionDate
      })
    },
    {
      name: I18n.t("Rec. qt"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        }
      },
      render: param => JsxRuntime.jsx(SupplierOrderListPage$SupplierOrderReceptionQuantityCell, {
        statuses: param.statuses,
        totalProductsQuantity: param.totalProductsQuantity,
        totalProductsExpectedQuantity: param.totalProductsExpectedQuantity
      })
    },
    {
      name: I18n.t("Status"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        },
        width: {
          NAME: "fr",
          VAL: 1.3
        }
      },
      render: param => JsxRuntime.jsx(OrderStatusBadges.make, {
        statuses: param.statuses
      })
    },
    {
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 65
        },
        width: {
          NAME: "px",
          VAL: 65
        }
      },
      render: param => JsxRuntime.jsx(OrderTableActions.make, {
        id: param.id,
        name: param.formattedName,
        statuses: param.statuses,
        onRequestNotification: notification => setNotification(param => notification)
      })
    }
  ];
  let banner = JsxRuntime.jsx(make, {
    notification: match$4[0],
    onRequestClose: () => setNotification(param => {})
  });
  let emptyState;
  let exit$2 = 0;
  if (state.currentPage !== 1 || state.searchQuery !== undefined) {
    exit$2 = 1;
  } else {
    let match$6 = state.filters;
    if (match$6.status !== undefined || match$6.issueDateRange !== undefined || match$6.receptionDateRange !== undefined) {
      exit$2 = 1;
    } else {
      emptyState = JsxRuntime.jsx(EmptyState.make, {
        illustration: Illustration.create,
        title: I18n.t("Welcome to the supplier orders space.")
      });
    }
  }
  if (exit$2 === 1) {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  if (pageSubtitle !== undefined) {
    return JsxRuntime.jsx(Scaffolded.make, {
      title: I18n.t("Supplier orders"),
      subtitle: pageSubtitle,
      state: state,
      dispatch: dispatch,
      columns: columns,
      filters: filters,
      actions: actions,
      banner: banner,
      searchBar: searchBar,
      emptyState: emptyState,
      defaultQueryVariables: defaultQueryVariables
    });
  } else {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
}

let make$1 = React.memo(SupplierOrderListPage);

export {
  SupplierOrderListNotificationBanner,
  ParentQuery,
  Query,
  Filters,
  Row,
  SupplierOrderReceptionQuantityCell,
  Scaffolded,
  make$1 as make,
}
/* make Not a pure module */
